import { Layout, Menu } from 'antd'
import { useEffect, useState } from 'react'
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { FaUsers, FaUserShield, FaUserTag } from 'react-icons/fa6'
import { IoStatsChart } from 'react-icons/io5'
import { TbMusic, TbMusicCog, TbMusicQuestion } from 'react-icons/tb'
import { RiFolderMusicFill } from 'react-icons/ri'
import type { MenuProps } from 'antd'
import { IoMdSettings } from 'react-icons/io'
import { RiPlayList2Fill } from 'react-icons/ri'
import { ItemType, MenuItemType } from 'antd/es/menu/interface'
import Settings from '../../features/settings/Settings'

import MusicRoutes from './MusicRoutes'
import UsersRoutes from './UsersRoutes'
import Statistic from '../../features/statistic/Statistic'
import { IoDocumentTextOutline } from "react-icons/io5";
import useUrlSegments from '../hooks/useUrlSegments'
import { useAppSelector } from '../redux/store'

const { Content, Sider } = Layout


export default function AuthorizedRoutes() {
  const defaultActiveKeys = useUrlSegments() //to handle reload, bookmark etc...
  const [collapsed, setCollapsed] = useState(false)
  const navigate = useNavigate()
  const role = useAppSelector((state) => state.auth.role)

  const menu: ItemType<MenuItemType>[] = [
    {
      label: 'Statistic',
      key: 'statistic',
      icon: <IoStatsChart />,
    },
  ]

  const menuUsers = [
    /*{
      label: 'Moderators',
      key: 'moderators',
      icon: <FaUserShield />,
    },*/
  ]

  if (role === 'admin' || role === 'moderator') {
    menuUsers.push(
      {
        label: 'Clients',
        key: 'clients',
        icon: <FaUserTag />,
      }
    )
  }

  if (role === 'admin' || role === 'muzred') {
    menuUsers.push(
      {
        label: 'Orders',
        key: 'orders',
        icon: <IoDocumentTextOutline />,
      },
    )
  }

  menu.push(
    {
      label: 'Users',
      key: 'users',
      icon: <FaUsers />,
      children: menuUsers,
    }
  )

  if (role === 'admin' || role === 'muzred') {
    menu.push(
      {
        label: 'Music',
        key: 'music',
        icon: <TbMusic />,
        children: [
          {
            label: 'Songs',
            key: 'songs',
            icon: <TbMusicCog />,
          },
          {
            label: 'Playlists',
            key: 'playlists',
            icon: <RiPlayList2Fill />,
          },
          {
            label: 'Styles',
            key: 'styles',
            icon: <RiFolderMusicFill />,
          },
          {
            label: 'Moods',
            key: 'moods',
            icon: <RiFolderMusicFill />,
          },
          {
            label: 'Businesses',
            key: 'businesses',
            icon: <RiFolderMusicFill />,
          },
          {
            label: 'Daytimes',
            key: 'daytimes',
            icon: <RiFolderMusicFill />,
          },
        ],
      },
    )
  }
  
  menu.push(
    {
      label: 'Settings',
      key: 'settings',
      icon: <IoMdSettings />,
    },
  )

  const handleNavigationMenu: MenuProps['onClick'] = (item) => {
    const path = item.keyPath
      .reverse()
      .map((item) => `${item}/`)
      .join('')
    navigate(`/${path}`)
  }

  return (
    <Layout>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={(value) => setCollapsed(value)}
      >
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={defaultActiveKeys}
          items={menu}
          onClick={handleNavigationMenu}
        />
      </Sider>
      <Content>
        <Routes>
          <Route path="*" element={<Navigate to={'/statistic'} />} />

          <Route path="/statistic" element={<Statistic />} />
          {(role === 'admin' || role === 'muzred') && (
            <Route path="/music/*" element={<MusicRoutes />} />
          )}
          <Route path="/users/*" element={<UsersRoutes />} />
          <Route path="settings" element={<Settings />} />
        </Routes>
      </Content>
    </Layout>
  )
}
